import { useContext } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { MeContext } from '../../contexts/me.context';

const ChatPatientLink = () => {
  const { clinicId, patientId } = useParams();
  const { me, selectClinic } = useContext(MeContext);
  const clinic = me.clinics.find(item => String(item.ID) === clinicId);
  if (!clinic || !patientId || !/^[a-z0-9-]+$/i.test(patientId)) {
    return (
      <div role="alert" className="p-6 text-gray-700 dark:text-gray-200">
        This patient link is unavailable for your account.
      </div>
    );
  }
  if (me.selectedClinic?.ID === clinic.ID) {
    return <Navigate to={`/patients/${patientId}`} replace />;
  }
  return (
    <div className="mx-auto max-w-lg p-6">
      <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Open patient record</h1>
      <p className="mt-2 text-gray-600 dark:text-gray-300">
        This record belongs to {clinic.name}. Switch clinics to continue.
      </p>
      <button
        type="button"
        onClick={() => selectClinic(clinic)}
        className="mt-6 rounded-lg bg-primary-600 px-4 py-3 font-medium text-white hover:bg-primary-700"
      >
        Continue in {clinic.name}
      </button>
    </div>
  );
};

export default ChatPatientLink;
